import { action } from '../../../lib/api';

export const setDrawerState = (key, value) => {
  action('SET_DRAWER_OPEN', { [key]: value });
};

/**
 * @param {'whatAreApps'} docId - The name of the document to open
 */
export const openDocDrawer = ({ docId, highlightedElementId }) => {
  action('SET_DOC_DRAWER_OPEN', { open: true, docId, highlightedElementId });
};

export const closeDocDrawer = () => {
  action('SET_DOC_DRAWER_OPEN', { open: false, docId: undefined });
};

export const openAppDocDrawer = () => {
  action('SET_APP_DOC_DRAWER_OPEN', { open: true });
};

export const closeAppDocDrawer = () => {
  action('SET_APP_DOC_DRAWER_OPEN', { open: false });
};

export const openLiveWorkflowLogsDrawer = () => {
  action('SET_LIVE_WORKFLOW_LOGS_DRAWER_OPEN', { open: true });
};

export const closeLiveWorkflowLogsDrawer = () => {
  action('SET_LIVE_WORKFLOW_LOGS_DRAWER_OPEN', { open: false });
};

export const openAppOutputDrawer = ({ statusId } = {}) => {
  action('SET_APP_OUTPUT_DRAWER', { open: true, statusId });
};

export const closeAppOutputDrawer = () => {
  action('SET_APP_OUTPUT_DRAWER', { open: false, statusId: null });
};

export const openAppIssueReportDrawer = () => {
  action('SET_APP_ISSUE_REPORT_DRAWER', { open: true });
};

export const closeAppIssueReportDrawer = () => {
  action('SET_APP_ISSUE_REPORT_DRAWER', { open: false });
};
